import {Injectable} from '@angular/core';
import {dependencyContainer, SERVER_CONNECTION_TOKEN} from "../../classes/appInjector";
import {fromPromise} from "rxjs/internal-compatibility";
import {debounceTime} from "rxjs/operators";
import {Subject} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ServerConnectionService {

  private adapter: ServerConnectionInterface;
  private _maxRequestCount = 20;
  private setToDefaultVal$ = new Subject();

  get maxRequestCount(){
    return this._maxRequestCount;
  }

  public isFastSignup:boolean;

  constructor() {
    this.adapter = dependencyContainer.get(SERVER_CONNECTION_TOKEN);
    this.setToDefaultVal$.pipe(debounceTime(10000)).subscribe(()=>{
      this._maxRequestCount = 20;
    })
  }

  connect() {
    this.adapter.connect();
  }

  isConnected() {
    return this.adapter.getSocket().connected;
  }

  setUnlimitedRequestCount(){
    this._maxRequestCount = 99999999;
    this.setToDefaultVal$.next(20)
  }

  /**
   * System events related to the socket connection and online users
   * @param event
   * @param callback
   */
  on(event: string, callback: CallableFunction) {
    if(event === 'NETWORK_LOST'){
      // @ts-ignore
      window.addEventListener('offline', callback);
    } else if(event === 'NETWORK_RESTORED')  {
      // @ts-ignore
      window.addEventListener('online',  callback);
    } else {
      return this.adapter.on(event, callback);
    }
  }

  /**
   * Actions performed by other team members on other devices
   * @param event
   * @param callback
   */
  onAction(event: string, callback: CallableFunction) {
    return this.adapter.onAction(event, callback);
  }

  emit(event:string, data, callback?: Function, silent?: boolean) {
    return this.adapter.emit(event, data, callback, silent);
  }

  onBeforeRequest(callback: Function) {
    this.adapter.on('__beforeRequest', callback);
  }

  onAfterRequest(callback: Function) {
    this.adapter.on('__afterRequest', callback);
  }

  getUsers() {
    return this.adapter.getUsers();
  }

  addObject(config, cb?){
    return fromPromise(this.emit('addObject', config, cb));
  }

  removeObject(itemId, cb?){
    return fromPromise(this.emit('removeObject', itemId, cb));
  }

  updateObject(itemConfig, cb?){
    if (this.isFastSignup && itemConfig.hasOwnProperty('groupId')){
      itemConfig.groupId = null;
    }
    return fromPromise(this.emit('updateObject', itemConfig, cb));
  }

  addConcreteItem(concreteConfig, cb?){
    return fromPromise(this.emit('addConcreteItem', concreteConfig, cb));
  }

  updateConcreteItemImage(object, cb?){
    return fromPromise(this.emit('updateConcreteItemImage', object, cb));
  }

  updateConcreteItem(concreteConfig, cb?){
    return fromPromise(this.emit('updateConcreteItem', concreteConfig, cb));
  }

  removeConcreteItem(concreteIdObj, cb?){
    return fromPromise(this.emit('removeConcreteItem', concreteIdObj, cb));
  }

  createGroup(group, cb?){
    return fromPromise(this.emit('createGroup', group, cb));
  }

  removeGroup(group, cb?){
    return fromPromise(this.emit('removeGroup', group, cb));
  }

  updateGroup(group, cb?){
    return fromPromise(this.emit('updateGroup', group, cb));
  }
}
